var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30207 6.86279L11.7264 2.42911C12.0794 2.07543 12.0794 1.48174 11.7264 1.12805C11.3735 0.774369 10.7811 0.774369 10.4281 1.12805L6.00375 5.56174L1.57939 1.12805C1.22644 0.774369 0.634001 0.774369 0.28106 1.12805C-0.071881 1.48174 -0.071881 2.07543 0.28106 2.42911L4.70543 6.86279L0.28106 11.2965C-0.071881 11.6502 -0.071881 12.2438 0.28106 12.5975C0.457531 12.7744 0.697028 12.8628 0.936524 12.8628C1.17602 12.8628 1.40291 12.7744 1.59199 12.5975L6.01635 8.16384L10.4407 12.5975C10.6172 12.7744 10.8567 12.8628 11.0962 12.8628C11.3357 12.8628 11.5626 12.7744 11.7516 12.5975C12.1046 12.2438 12.1046 11.6502 11.7516 11.2965L7.30207 6.86279Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.22bb8f63bd5364d61d8e16399c9c07bd.svg";
export { ForwardRef as ReactComponent };